// extracted by mini-css-extract-plugin
export default {"survey_title":"index_survey_title_EUge8 clearfix","count_box":"index_count_box_wPmf0","count":"index_count_WpsEC","logo":"index_logo_5qmgT","img":"index_img_NFHAK"};